import Tabs from "@/v2-backoffice-client/components/tabs"
import { CUSTOMER_VIEW_CRM_MERGES } from "@/v2-backoffice-client/customer/customer.constants"
import { useCustomerMergesQuery } from "@/v2-backoffice-client/customer/merge/customer.merge.query"
import { CUSTOMER_MERGE_OPEN_STATUSES } from "@/v2-backoffice-client/customer/merge/customer.merge.utils"

// The Customers page's CRM Merges tab trigger: how many recorded HubSpot
// company merges still want something - a decision, a consolidation about
// to run, a run in progress, or the sync's next walk. Owns its own read of
// the query, which Apollo dedupes against the board's, so the count is
// live whichever tab is open and drops as merges settle.
function CustomerMergeTabTrigger() {
  const { data, loading } = useCustomerMergesQuery()
  const count = (data?.getCustomerMerges ?? []).filter((merge) =>
    CUSTOMER_MERGE_OPEN_STATUSES.includes(merge.Status),
  ).length

  return (
    <Tabs.Trigger
      value={CUSTOMER_VIEW_CRM_MERGES}
      iconSrc="code-merge"
      isLoading={loading}
      count={count}
    >
      CRM Merges
    </Tabs.Trigger>
  )
}

export default CustomerMergeTabTrigger
